export const SOURCE_TYPE_UPLOAD = 'Upload';
export const SOURCE_TYPE_DEFAULT = SOURCE_TYPE_UPLOAD;
export const SOURCE_TYPE_GOOGLE = 'Google';
export const SOURCE_TYPE_FACEBOOK = 'Facebook';
export const SOURCE_TYPE_YELP = 'Yelp';
export const SOURCE_TYPE_EXTERNAL_WEBSITE = 'ExternalWebsite';
export const SOURCE_TYPE_STOCK = 'Stock';
export const SOURCE_TYPE_MENU = 'Menu';
export const SOURCE_TYPE_TEAM_MEMBER = 'TeamMember';
